import { HFlow, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, Text } from 'bold-ui'
import { useHistory, useRouteMatch } from 'react-router'

import { CONSULTA_SEGUIMENTO_URL_MODAL } from '../../consulta-seguimento/model-consultaSeguimento'

interface ConsultaSeguimentoEditWarningModalProps {
  open: boolean
  onClose: () => void
}

export function ConsultaSeguimentoEditWarningModal(props: Readonly<ConsultaSeguimentoEditWarningModalProps>) {
  const { open, onClose } = props

  const history = useHistory()
  const match = useRouteMatch()

  const goToConsultaSeguimento = () => {
    history.push(`${match.url}${CONSULTA_SEGUIMENTO_URL_MODAL}`)
    onClose()
  }

  return (
    <Modal open={open} size='small' closeOnBackdropClick={false} onClose={onClose}>
      <ModalHeader
        title='É necessário editar a entrevista de seguimento'
        icon={{
          name: 'banOutline',
          fill: 'danger',
        }}
      />
      <ModalBody>
        <Text>
          As perguntas da Entrevista de seguimento precisam ser atualizadas após alterações do resultado do M-Chat-R.
        </Text>
      </ModalBody>
      <ModalFooter>
        <HFlow alignItems='center' justifyContent='flex-end'>
          <ModalFooterButton kind='primary' onClick={goToConsultaSeguimento}>
            Editar entrevista de seguimento
          </ModalFooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
